import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import withWidth from '@material-ui/core/withWidth';
import ProjectLanguageSelector from '../core/ProjectLanguageSelector';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ActionText from '../core/ActionText';
import { ENTITLEMENTS } from '../application-core/constants';
import { checkResourceEntitlements } from '../core/utils/utils';
import withGS from '../core/withGShoc';
import CreateNodeDialogContainer from './CreateNodeDialogContainer';
import CreateResourceDialog from './CreateResourceDialog';
import PropertyData from './PropertyData';
import ResourceSearch from './ResourceSearch';
import ResourceStructure from './ResourceStructure';
import { globalStyles } from '../core/style/gstheme';
import CreateButton from '../core/CreateButton';
import GetStarted from '../application-core/GetStarted';

const styles = Object.assign({}, globalStyles);

function PropertyCreateDialog(props) {

  const childExclusions = props.data[props.childProperty] ? props.data[props.childProperty] : [];

  return (
    <CreateNodeDialogContainer
      ontologyIRI={props.ontologyIRI}
      useSlashIRI={props.useSlashIRI}
      useUuidIRI={props.useUuidIRI}
      iriOptions={props.iriOptions}
      button={props.bigButton ? <CreateButton label="Add" /> : null}
      parentIRI={props.data.id}
      graph={props.graph}
      onlyComponentResources={true}
      onAddExistingNode={props.onAddExistingNode}
      onAddNewNode={props.onAddNewNode(props.titlePath, "")}
      disableMultiple={props.disableMultiple}
      searchClass={props.searchClass}
      searchClassFilter={[
        "http://www.w3.org/2002/07/owl#Class",
        "http://www.w3.org/2002/07/owl#AnnotationProperty",
        "http://www.w3.org/2002/07/owl#DatatypeProperty",
        "http://www.w3.org/2002/07/owl#ObjectProperty"
      ]}
      exclude={[
        ...childExclusions,
        "https://graphifi.com/schema/xowl/topAnnotationProperty",
        "http://www.w3.org/2002/07/owl#topObjectProperty",
        "http://www.w3.org/2002/07/owl#topDataProperty",
        "http://www.w3.org/2002/07/owl#Thing"
      ]}
      createDialog={CreateResourceDialog}
      title="Add Property"
      placeholder="Enter property label"
      name="Add a top property"
    />
  );
}

class PropertyView extends Component {

  componentDidMount() {
    if (this.props.activeProperty && this.props.data[this.props.childProperty])
      this.props.onFoundProperty(this.props.data[this.props.childProperty])(this.props.activeProperty);
  }

  excludeByPathFunction = (id) => {
    const ebp = [];
    ebp.push({
      predicate: [
        "http://www.w3.org/2000/01/rdf-schema#subPropertyOf"
      ],
      target: id,
      reverse: true
    });
    ebp.push({
      predicate: [
        "https://graphifi.com/schema/xowl/hasSubProperty"
      ],
      target: id,
      reverse: true
    });
    if (this.props.childProperty === "subPropertyOf") {
      ebp.push({
        predicate: [
          "http://www.w3.org/2000/01/rdf-schema#subPropertyOf"
        ],
        target: id,
        pathOperators: ["+"]
      });
    }
    if (this.props.childProperty === "hasSubProperty") {
      ebp.push({
        predicate: [
          "https://graphifi.com/schema/xowl/hasSubProperty"
        ],
        target: id,
        pathOperators: ["+"]
      });
    }
    return ebp;
  };

  render() {

    const { activeProperty, classes, ontologyIRI, onSelect, onAddNewNode, expandNode, collapseNode, selectedTitlePath, onAddExistingNode,
      data, appBar, foundRef, defaultLang, foundPath, onFoundProperty, childProperty, searchClass, buildLink, titlePath, viewLang, hiddenProps,
      viewWidth, width, onFullViewChange, onViewWidthChange, isFullView, onCollapse, availableAnnotationProperty, useSlashIRI, useUuidIRI,
      foundTime, onDeleteNode, expandedPaths, project, onBreakLink, graph, onSelectViewLanguage, iriOptions, excludeDeprecated } = this.props;

    const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_ONTOLOGY);
    const isLargeScreen = width === "lg" || width === "xl";

    return (
      <div>
        <div className={classes.controlPanel}
          style={{
            ...(isFullView) && { width: 'calc(100% - 100px)' },
            ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (340 + (viewWidth * 100)) }
          }}>
          <div className={classes.views}>
            {appBar}
          </div>
          <div className={classes.controlPanelInner}>
            <div className={classes.controlPanelAdd}>
              {!isReadOnly && data[childProperty] && data[childProperty].length > 0 &&
                <CreateNodeDialogContainer
                  ontologyIRI={ontologyIRI}
                  useSlashIRI={useSlashIRI}
                  useUuidIRI={useUuidIRI}
                  parentIRI={data.id}
                  graph={graph}
                  onlyComponentResources={true}
                  iriOptions={iriOptions}
                  onAddExistingNode={onAddExistingNode}
                  onAddNewNode={onAddNewNode(titlePath, "")}
                  searchClass={searchClass}
                  searchClassFilter={[
                    "http://www.w3.org/2002/07/owl#Class",
                    "http://www.w3.org/2002/07/owl#AnnotationProperty",
                    "http://www.w3.org/2002/07/owl#DatatypeProperty",
                    "http://www.w3.org/2002/07/owl#ObjectProperty"
                  ]}
                  createDialog={CreateResourceDialog}
                  existing={data[childProperty]}
                  exclude={
                    [
                      "https://graphifi.com/schema/xowl/topAnnotationProperty",
                      "http://www.w3.org/2002/07/owl#topObjectProperty",
                      "http://www.w3.org/2002/07/owl#topDataProperty",
                      "http://www.w3.org/2002/07/owl#Thing"
                    ]}
                  title="Add Property"
                  placeholder="Enter property label"
                  name="Add a top property"
                />
              }
            </div>
            <div className={classes.controlPanelSearch}>
              {data[childProperty] && data[childProperty].length > 0 &&
                <ResourceSearch
                  searchClass={searchClass}
                  graph={graph}
                  ontologyIRI={ontologyIRI}
                  onFoundResource={onFoundProperty(data[childProperty])}
                  defaultLang={viewLang || defaultLang} />
              }
            </div>
          </div>
          <div data-test="property-tree"
            className={classes.tree}
            style={
              {
                ...(isFullView) && { width: 'calc(100% - 100px)' },
                ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (340 + (viewWidth * 100)) }
              }
            }>
            {data[childProperty] && data[childProperty].length > 0 &&
              <div className={classes.treeOptions}>
                <div data-test="editing-mode" style={{ paddingTop: 4, paddingBottom: 4, overflow: 'auto' }}>
                  {excludeDeprecated &&
                    <Tooltip title={<span data-test="deprecated-message">{"Deprecated properties are hidden"}</span>}>
                      <span data-test={"deprecated-hidden"} onClick={onCollapse} style={{ float: 'right', marginLeft: 4, color: '#ff6600' }}>
                        <InfoIcon style={{ transform: 'translateY(3px)' }} />
                      </span>
                    </Tooltip>
                  }
                  <Tooltip title="Collapse all">
                    <span data-test={"collapse-all"} onClick={onCollapse} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-collapse-all"} size="small">
                        <UnfoldLessIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Toggle full view mode">
                    <span data-test={"full-view"} onClick={onFullViewChange} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-full-view"} size="small">
                        {isFullView ?
                          <FullscreenExitIcon />
                          :
                          <FullscreenIcon />
                        }
                      </IconButton>
                    </span>
                  </Tooltip>
                  {isLargeScreen &&
                    <Tooltip title="Change hierarchy width">
                      <span data-test={"split-view-" + viewWidth} onClick={onViewWidthChange} style={{ float: 'right' }}>
                        <IconButton data-test={"option-split"} size="small">
                          <VerticalSplitIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                </div>
              </div>
            }
            {data[childProperty] && data[childProperty].length > 0 ?
              <ResourceStructure
                filter={true}
                isReadOnly={isReadOnly}
                defaultLang={defaultLang}
                foundPath={foundPath}
                foundRef={foundRef}
                buildLink={buildLink}
                graph={graph}
                iriOptions={iriOptions}
                activeResource={activeProperty}
                onBreakLink={onBreakLink}
                titlePath={titlePath}
                titleTree={[]}
                excludeDeprecated={excludeDeprecated}
                viewLang={viewLang}
                selectedTitlePath={selectedTitlePath}
                foundTime={foundTime}
                childProperty={childProperty}
                expandedPaths={expandedPaths}
                onAddExistingNode={onAddExistingNode}
                onAddNewNode={onAddNewNode && searchClass !== "http://www.w3.org/2002/07/owl#AnnotationProperty" ? onAddNewNode : null}
                onDeleteNode={onDeleteNode}
                expandNode={expandNode}
                collapseNode={collapseNode}
                ontologyIRI={ontologyIRI}
                useSlashIRI={useSlashIRI}
                useUuidIRI={useUuidIRI}
                data={data}
                path=""
                onSelect={onSelect}
                searchClass={searchClass}
                excludeByPath={this.excludeByPathFunction}
                searchClassFilter={[
                  "http://www.w3.org/2002/07/owl#Class",
                  "http://www.w3.org/2002/07/owl#DatatypeProperty",
                  "http://www.w3.org/2002/07/owl#AnnotationProperty",
                  "http://www.w3.org/2002/07/owl#ObjectProperty"
                ]}
                permissions={[ENTITLEMENTS.EDIT_ONTOLOGY]}
                createDialog={CreateResourceDialog}
                addTitle="Add Subproperty"
              />
              :
              isReadOnly ?
                <ActionText offset="85px">No properties</ActionText>
                :
                <GetStarted text="Add a property to get started." action={
                  <PropertyCreateDialog bigButton={true} disableMultiple={true} {...this.props} />
                } />
            }
          </div>
        </div>
        <div data-test="language-panel" className={classes.viewLanguagePanel}>
          <ProjectLanguageSelector selectedLang={viewLang} includeLabel={false} onSelect={onSelectViewLanguage} />
        </div>
        {!isFullView &&
          <div data-test="info-panel"
            className={classes.infoPanel}
            style={
              {
                ...(!isFullView && viewWidth !== 0) && { left: (380 + (viewWidth * 100)) }
              }
            }>
            {
              data[childProperty] && data[childProperty].length > 0 ?
                (
                  activeProperty === null ?
                    <ActionText offset="180px">Select a property to view the detail.</ActionText>
                    :
                    <PropertyData
                      key={activeProperty}
                      project={project}
                      availableAnnotationProperty={availableAnnotationProperty}
                      graph={graph}
                      hiddenProps={hiddenProps}
                      excludeDeprecated={excludeDeprecated}
                      viewLang={viewLang}
                      buildLink={buildLink}
                      searchClass={searchClass}
                      propertyIRI={activeProperty}
                      ontologyIRI={ontologyIRI}
                      onDeleteProperty={onDeleteNode} />
                )
                :
                <ActionText offset="180px">When properties are created you will be able to view the detail here.</ActionText>
            }
          </div>
        }
      </div>
    );
  }
}

PropertyView.defaultProps = {
  viewWidth: 0
};

PropertyView.propTypes = {
  classes: PropTypes.object,
  buildLink: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired,
  searchClass: PropTypes.string.isRequired,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  activeProperty: PropTypes.string,
  graph: PropTypes.string.isRequired,
  titlePath: PropTypes.array.isRequired,
  childProperty: PropTypes.string.isRequired,
  selectedTitlePath: PropTypes.array,
  expandNode: PropTypes.func.isRequired,
  collapseNode: PropTypes.func.isRequired,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired,
  onFoundProperty: PropTypes.func.isRequired,
  excludeDeprecated: PropTypes.bool,
  viewLang: PropTypes.string,
  onBreakLink: PropTypes.func.isRequired,
  foundPath: PropTypes.string,
  onSelectViewLanguage: PropTypes.func,
  foundTime: PropTypes.number,
  foundRef: PropTypes.object,
  project: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  isFullView: PropTypes.bool,
  viewWidth: PropTypes.number,
  onCollapse: PropTypes.func,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  availableAnnotationProperty: PropTypes.array,
  hiddenProps: PropTypes.array,
  iriOptions: PropTypes.object
};

export default withWidth()(withStyles(styles)(withGS(PropertyView)));